import security from '../../../utils/security'
import http from '../../../utils/http'
import {
  AGREEMENT_SETTLEMENT_LIST_LOADING,
  AGREEMENT_SETTLEMENT_LIST_SUCCESS,
  AGREEMENT_SETTLEMENT_LIST_ERROR,
} from './mutation-types'

const state = {
  loading: false,
  error: '',
  items: []
}

function error (error) {
  return {type: AGREEMENT_SETTLEMENT_LIST_ERROR, error}
}

function loading (loading) {
  return {type: AGREEMENT_SETTLEMENT_LIST_LOADING, loading}
}

function success (items) {
  return {type: AGREEMENT_SETTLEMENT_LIST_SUCCESS, items}
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
}

const actions = {
  getItems ({commit}, agreementId) {
    commit(loading(true))
    commit(error(null))
    const page = '/agreements/' + agreementId + '/settlements?order[order]=asc&order[name]=asc&'

    return http.fetch(page)
      .then(response => {
        commit(loading(false))
        return response.json()
      })
      .then(data => {
        commit(success(data['hydra:member']))
      })
      .catch(e => {
        commit(loading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        commit(error(e.message))
      })
  },
}

const mutations = {
  [AGREEMENT_SETTLEMENT_LIST_ERROR] (state, payload) {
    state.error = payload.error
  },
  [AGREEMENT_SETTLEMENT_LIST_LOADING] (state, payload) {
    state.loading = payload.loading
  },
  [AGREEMENT_SETTLEMENT_LIST_SUCCESS] (state, payload) {
    state.items = payload.items
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/agreement/settlement-list.js